import { getApiUrl } from 'modules/enrollment-platform-api'
import axios from 'axios'
import {
  UpdateBenefitRealtimeCascadeStatusDto,
  UpdateBenefitRealtimeDto,
} from './dtos'
import getApiToken from 'enrollment-platform/api/get-api-token'

/**
 * Updates individual fields on a benefit realtime record
 * Only provided fields will be updated.
 * @param benefitId - The benefit ID to update
 * @param data - The benefit realtime data to update
 */
export const updateBenefitRealtime = async (
  benefitId: string,
  data: UpdateBenefitRealtimeDto
): Promise<void> => {
  const idToken = getApiToken()
  await axios.patch(`api/v1/benefits-realtime/${benefitId}`, data, {
    baseURL: getApiUrl(),
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken,
    },
  })
}

/**
 * Updates benefit realtime status via cascade-status endpoint for real-time updates
 * @param benefitId - The benefit ID to update
 * @param data - The cascade status data (status, statusDate, updatedBy)
 */
export const updateBenefitRealtimeCascadeStatus = async (
  benefitId: string,
  data: UpdateBenefitRealtimeCascadeStatusDto
): Promise<void> => {
  const idToken = getApiToken()
  await axios.patch(
    `api/v1/benefits-realtime/${benefitId}/cascade-status`,
    data,
    {
      baseURL: getApiUrl(),
      headers: {
        'Content-Type': 'application/json',
        Authorization: idToken,
      },
    }
  )
}
